<div class="textfield" [ngClass]="{ error: hasError }">
  <label [for]="id">{{ label | i18next }}</label>
  <div class="input {{successIcon ? 'has-prefix' : ''}}">
    <span class="prefix"><i class="fa fa-check" aria-hidden="true" *ngIf="successIcon"></i></span>
    <input
      [type]="type"
      [id]="id"
      [name]="id"
      [max]="max"
      placeholder="{{ placeholder ? (placeholder | i18next) : '' }}"
      [ngClass]="{ error: hasError }"
      [attr.aria-required]="isRequired"
      [attr.aria-invalid]="hasError"
      [attr.aria-describedby]="errorId"
      [(ngModel)]="value"
      (blur)="markAsTouched()"
      (keydown)="handleKeydown($event)"
      [readOnly]="readonly"
      [disabled]="!!isLoading"
    />
    <span class="suffix"><i class="fa fa-exclamation-triangle" aria-hidden="true" *ngIf="hasError"></i></span>
  </div>
  <span class="app-error-text" [id]="errorId">
    {{ hasError ? (errorText | i18next) : '' }}
  </span>
</div>
